module.exports = __webpack_public_path__ + "static/media/left-arrow-icon.6e3c11eb.svg";